import InvelpsGlobalNav from "./InvelpsGlobalNav";

/** En-tête unique : barre verte INVELPS (nav + Synthèse / Leaders / Flux intégrés) */
export default function MarketPageShell({ darkMode, onToggleDark }) {
  return <InvelpsGlobalNav darkMode={darkMode} onToggleDark={onToggleDark} />;
}
